import { useState } from 'react';
import { randomId } from '../random-id';
export var useId = function (prefix, id) {
    var randId = useState(randomId(prefix))[0];
    return id !== null && id !== void 0 ? id : randId;
};
